import { render, staticRenderFns } from "./LoyaltyReport.vue?vue&type=template&id=ecd62da8&"
import script from "./LoyaltyReport.vue?vue&type=script&lang=js&"
export * from "./LoyaltyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports